<template>
    <div class="container">
        <template v-if="pageFlag">
            <div class="wrapper">
                <img src="./assets/img/wwjlogo.png" alt="" class="wwj-app" />
                <img src="./assets/img/toplogo.png" alt="" class="wwjlogo" />
                <img src="./assets/img/topadorn.png" alt="" class="topadorn" />
                <!-- <template v-if="routeId==1">
                    <img  src="./assets/img/getnow.png" alt="" class="getnow">
                </template> -->
                <div class="footer">
                    <img
                        src="./assets/img/bottobag.png"
                        alt=""
                        class="bottobag"
                    />
                    <img
                        src="./assets/img/bottomjacket.png"
                        alt=""
                        class="bottomjacket"
                    />
                    <img
                        src="./assets/img/bottomphone.png"
                        alt=""
                        class="bottomphone"
                    />
                    <img
                        src="./assets/img/bottombeer.png"
                        alt=""
                        class="bottombeer"
                    />
                    <img
                        src="./assets/img/bottomclouds.png"
                        alt=""
                        class="bottomclouds"
                    />
                </div>
                <!-- 20赞 -->
                <template v-if="routeId == 1">
                    <img
                        src="./assets/img/prizetwenty.png"
                        alt=""
                        class="prizetwenty"
                    />
                    <img
                        @click="getPhone"
                        src="./assets/img/getnow.png"
                        alt=""
                        class="getnow"
                    />
                </template>

                <!-- 40赞 -->
                <template v-if="routeId == 2">
                    <img
                        src="./assets/img/prizeforty.png"
                        alt=""
                        class="prizetwenty"
                    />
                    <img
                        @click="getPrizeSecond"
                        src="./assets/img/getnow.png"
                        alt=""
                        class="getnow"
                    />
                </template>

                <!-- 60赞 -->
                <template v-if="routeId == 3">
                    <!-- testFlag -->
                    <img
                        src="./assets/img/prizesixty.png"
                        alt=""
                        class="prizetwenty"
                    />
                    <img
                        @click="getPrizeThree"
                        src="./assets/img/getnow.png"
                        alt=""
                        class="getnow"
                    />
                </template>
            </div>
        </template>
        <!-- downloadApp -->
        <template v-if="!pageFlag">
            <div class="rule-wrapper">
                <img src="./assets/img/rules.png" alt="" class="rules" />
                <img
                    src="./assets/img/downloadgetprize.png"
                    alt=""
                    class="downloadgetprize"
                />
                <!-- <img src="./assets/img/downloadapp.png" alt="" class="downloadapp"> -->
                <div ref="jumpApp" @click="jumpNew" class="downloadapp"></div>
            </div>
        </template>
    </div>
</template>

<script>
import Rem from './assets/rem';
import services from './services';
export default {
    mounted() {
        function onBridgeReady() {
            WeixinJSBridge.call('hideOptionMenu');
        }
        if (typeof WeixinJSBridge == 'undefined') {
            if (document.addEventListener) {
                document.addEventListener(
                    'WeixinJSBridgeReady',
                    onBridgeReady,
                    false
                );
            } else if (document.attachEvent) {
                document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
                document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
            }
        } else {
            onBridgeReady();
        }
        //匹配动态路由
        const id = this.$route.params.id;
        if (id == 'phone') {
            this.routeId = 1;
        } else if (id == 'bag') {
            this.routeId = 2;
        } else if (id == 'shirt') {
            this.routeId = 3;
        }
        //验证跳转
        let sessionVal = sessionStorage.getItem('name');
        if (sessionVal !== 'verifyUser') {
            this.pageFlag = false;
        }
    },
    data() {
        return {
            routeId: '', //$route flag
            pageFlag: true, //true
            //页面二 data
            userSelectF: false, //prize select1 flag
            userSelectS: false, //prize select2 flag
            selectEmptyF: true, //empty select1 flag
            selectEmptyS: true, //empty select2 flag
            testFlag: true, //测试rflag
            isGet: false, //提交flag
            prizeId: '',
            //页面三 data
            getBeerPrize: false,
            getFreePrize: false,
            prizeIdThree: '',
            isGetThree: false,
            //截取
            winUrl: '',
            code: '',
        };
    },
    watch: {},
    methods: {
        getPhone() {
            services
                .addActive({
                    activityId: 16,
                    title: '现场集赞活动',
                    content: 16,
                })
                .then((res) => {
                    if (res.returnCode == 0) {
                        // alert("领取成功");
                        // console.log(res);
                        this.pageFlag = false;
                    } else {
                        alert(res.returnMessage);
                    }
                });
        },

        getPrizeSecond() {
            services
                .addActive({
                    activityId: 16,
                    title: '现场集赞活动',
                    content: 17,
                })
                .then((res) => {
                    if (res.returnCode == 0) {
                        // alert("领取成功");
                        // console.log(res);
                        this.pageFlag = false;
                    } else {
                        // console.log(res);
                        alert(res.returnMessage);
                    }
                });
        },

        getPrizeThree() {
            services
                .addActive({
                    activityId: 16,
                    title: '现场集赞活动',
                    content: 18,
                })
                .then((res) => {
                    if (res.returnCode == 0) {
                        // alert("领取成功");
                        // console.log(res);
                        this.pageFlag = false;
                    } else {
                        alert(res.returnMessage);
                    }
                });
        },
        //跳转
        jumpNew() {
            window.open(
                'https://a.app.qq.com/o/simple.jsp?pkgname=com.sdo.qihang.wenbo'
            );
        },
    },
};
</script>

<style lang="scss" scoped>
body {
    margin: 0 auto;
    /* max-width: 750px; */
}

@media screen and (min-width: 750px) {
    body {
        width: 750px;
    }
}
//浮动动画
@keyframes heart {
    from {
        margin-top: 0px;
    }
    to {
        margin-top: -10px;
    }
}

//流畅
@keyframes heart {
    from {
        transform: translate(0, 0);
    }
    to {
        transform: translate(0, 10px);
    }
}
.container {
    .wrapper {
        width: 100%;
        height: 100%;
        background: url('./assets/img/bg.jpg') no-repeat;
        position: relative;
        //base css
        .wwj-app {
            position: absolute;
            top: 4%;
            left: 8%;
            width: 0.81rem;
            height: 1.04rem;
        }
        .wwjlogo {
            position: absolute;
            top: 17%;
            left: 50%;
            width: 6.02rem;
            height: 2.34rem;
            margin-left: -3.01rem;
            margin-top: -1.17rem;
        }
        .topadorn {
            position: absolute;
            top: 55%;
            left: 49%;
            width: 6.69rem;
            height: 9.08rem;
            margin-left: -3.345rem;
            margin-top: -4.54rem;
            z-index: 2;
        }
        .footer {
            position: absolute;
            bottom: 0%;
            left: 0%;
            width: 100%;
            height: 2.87rem;
            background: url('./assets/img/bottomcloudflower.png') no-repeat;
            .bottobag {
                position: absolute;
                bottom: 0%;
                left: 20%;
                width: 2.27rem;
                height: 2.54rem;
                margin-left: -1.135rem;
                margin-top: -1.27rem;
                z-index: 2;
            }
            .bottomjacket {
                position: absolute;
                bottom: 0%;
                left: 48%;
                width: 3.47rem;
                height: 2.44rem;
                margin-left: -1.735rem;
                margin-top: -1.22rem;
                z-index: 1;
                animation: heart 1s ease-in-out 0s infinite alternate;
            }
            .bottomphone {
                position: absolute;
                bottom: -5%;
                left: 72%;
                width: 2.56rem;
                height: 2.57rem;
                margin-left: -1.28rem;
                margin-top: -1.285rem;
            }
            .bottombeer {
                position: absolute;
                bottom: 0%;
                left: 82%;
                width: 1.77rem;
                height: 2.72rem;
                margin-left: -0.885rem;
                margin-top: -1.36rem;
                animation: heart 1.3s ease-in-out 0s infinite alternate;
            }
            .bottomclouds {
                position: absolute;
                bottom: 0%;
                left: 0%;
                width: 100%;
                height: 0.94rem;
                z-index: 4;
            }
        }

        //中部图1
        .prizetwenty {
            position: absolute;
            top: 49%;
            left: 49%;
            width: 7.22rem;
            height: 6.89rem;
            margin-left: -3.61rem;
            margin-top: -3.445rem;
        }
        .phonetext {
            position: absolute;
            top: 74%;
            left: 50%;
            width: 2.48rem;
            height: 0.25rem;
            margin-left: -1.24rem;
            margin-top: -0.125rem;
        }
        .getnow {
            position: absolute;
            top: 80%;
            left: 50%;
            width: 2.76rem;
            height: 0.71rem;
            margin-left: -1.38rem;
            margin-top: -0.355rem;
            z-index: 20;
        }
        //中部图2
        .fortybeer {
            position: absolute;
            bottom: 24%;
            left: 28%;
            width: 3.03rem;
            height: 0.59rem;
            margin-left: -1.515rem;
            margin-top: -0.295rem;
            z-index: 8;
        }
        .fortybag {
            position: absolute;
            bottom: 24%;
            right: 10%;
            width: 3.03rem;
            height: 0.59rem;
            margin-left: -1.515rem;
            margin-top: -0.295rem;
            z-index: 8;
        }
        //2 select
        .selectempty {
            position: absolute;
            bottom: 25%;
            left: 9%;
            width: 0.36rem;
            height: 0.36rem;
            margin-left: 0.18rem;
            margin-top: 0.18rem;
            z-index: 8;
        }
        .selectempty2 {
            position: absolute;
            bottom: 25%;
            right: 42%;
            width: 0.36rem;
            height: 0.36rem;
            margin-left: 0.18rem;
            margin-top: 0.18rem;
            z-index: 8;
        }
        .selectpitch {
            position: absolute;
            bottom: 25%;
            left: 9%;
            width: 0.36rem;
            height: 0.36rem;
            margin-left: 0.18rem;
            margin-top: 0.18rem;
            z-index: 9;
        }
        .selectpitch2 {
            position: absolute;
            bottom: 25%;
            right: 42%;
            width: 0.36rem;
            height: 0.36rem;
            margin-left: 0.18rem;
            margin-top: 0.18rem;
            z-index: 9;
        }
    }
    .rule-wrapper {
        position: relative;
        width: 100%;
        height: 100%;
        background: url('./assets/img/bg.jpg') no-repeat;
        .rules {
            position: absolute;
            top: 49%;
            left: 50%;
            width: 7.2rem;
            height: 6.89rem;
            margin-left: -3.6rem;
            margin-top: -3.445rem;
        }
        .downloadgetprize {
            position: absolute;
            bottom: 22%;
            left: 50%;
            width: 5.33rem;
            height: 0.73rem;
            margin-left: -2.665rem;
            margin-top: -0.365rem;
        }
        .downloadapp {
            position: absolute;
            bottom: 15%;
            left: 50%;
            width: 3.11rem;
            height: 0.8rem;
            margin-left: -1.555rem;
            margin-top: -0.2rem;
            background: url('./assets/img/downloadapp.png') no-repeat;
        }
    }
}
</style>
